import {React, useState} from 'react';
import './NavBar.css';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginLogoutButtons from './pages/LoginLogoutButtons';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const goToHome = () => {
    if (location.pathname.startsWith('/atsg/')) {
      navigate('/atsg/home'); // Navigate to the SAAS tool home page
    } else if (location.pathname === '/devops-tools') {
      navigate('/devops-tools'); // Stay on DevOps Tools page
    } else {
      navigate('/'); // Navigate to landing page for other paths
    }
  };

  // Determine the title based on current route
  const getPageTitle = () => {
    if (location.pathname.startsWith('/atsg/')) {
      return 'SAAS Tool';
    }
    if (location.pathname === '/tools') {
      return 'XiO Support Tools';
    }
    if (location.pathname === '/devops-tools') {
      return 'DevOps Tools';
    }
    if (location.pathname.startsWith('/sso/')) {
      return 'SSO Tool';
    }
    return 'XiO Support Tools';
  };
  return (
    <nav className="flex flex-row grow flex-wrap text-white sticky justify-between h-15 place-items-center rounded-md bg-gradient-to-r from-[#004A80] to-[#004A80]">
      <div>
        <img src={require("./Images/logo.png")} alt="Crestron Logo" class="w-11 h-11 ml-3" />
      </div>
      <div class="whitespace-nowrap text-xl font-bold ">
        {getPageTitle()}
      </div>
      <div className="flex justify-center w-100 gap-2">
        <div>
          <button type="button" onClick={goToHome} >
            <img src={require("./Images/home-button.png")} alt="Home Page" className="w-9 h-9 m-1 mr-2"/>
          </button>
        </div>
        <div class="mr-2">
          <LoginLogoutButtons/>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;